<template>
  <div class="ur-sel-shell">
    <header class="ur-sel-header">
      <div class="ur-sel-header-logo">
        <img :src="logoUrl" class="ur-sel-header-logo-img" alt="logo" />
      </div>
      <span class="ur-sel-header-title" :title="headerTitle">{{ headerTitle }}</span>
      <div class="ur-sel-header-right">
        <span class="ur-sel-status" :class="'ur-sel-status-' + statusKey.toLowerCase()">
          {{ $t('URBANRENEWAL_SELECT.STATUS.' + statusKey) }}
        </span>
        <button class="ur-sel-logout" type="button" @click="handleLogout">
          {{ $t('URBANRENEWAL_SELECT.LAYOUT.LOGOUT') }}
        </button>
      </div>
    </header>
    <main class="ur-sel-body">
      <slot />
    </main>
  </div>
</template>

<script>
import UrbanRenewalSelectService from '@/services/UrbanRenewalSelectService';
import LoginValidationService from '@/services/LoginValidationService';
import responsive from '@/views/urbanrenewal/responsive';
import '@/assets/urbanrenewal/urbanrenewal-theme.css';

export default {
  name: 'UrbanRenewalSelectLayout',

  mixins: [responsive],

  data() {
    return {
      logoUrl: require('@/assets/images/UPGPT.png'),
    };
  },

  computed: {
    project() {
      return this.$store.state.urbanRenewalSelect.project || UrbanRenewalSelectService.getProject();
    },

    // 頂欄左側：桌機/平板「建案名 系統名」；手機只留建案名省空間（無建案名才退回系統名）
    headerTitle() {
      const sys = this.$t('URBANRENEWAL_SELECT.LAYOUT.SYSTEM_TITLE');
      const name = this.project && this.project.project_name;
      if (this.isMobile) return name || sys;
      return name ? `${name} ${sys}` : sys;
    },

    lastUpdated() {
      return this.$store.state.urbanRenewalSelect.lastUpdated;
    },

    dirty() {
      return this.$store.state.urbanRenewalSelect.dirty;
    },

    // 狀態標籤（FR §4.2）：截止日已過 → LOCKED；有未儲存變更 → DRAFT（選配試算中）；
    // 已存且與後端一致 → SUBMITTED（已儲存）；否則 DRAFT。
    statusKey() {
      const deadline = this.project && this.project.selection_deadline;
      if (deadline) {
        const now = new Date();
        const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
        if (todayStr > deadline) return 'LOCKED';
      }
      if (this.dirty) return 'DRAFT';
      if (this.lastUpdated) return 'SUBMITTED';
      return 'DRAFT';
    },
  },

  mounted() {
    const tenant = window.localStorage.getItem('tenant');
    if (tenant) {
      LoginValidationService.getUrbanRenewalLogo(tenant)
        .then(res => {
          if (res.data && res.data.logo_url) {
            this.logoUrl = res.data.logo_url;
          }
        })
        .catch(() => {});
    }
  },

  methods: {
    handleLogout() {
      const tenant = window.localStorage.getItem('tenant') || '';
      UrbanRenewalSelectService.clearSession();
      this.$router.push({
        path: '/urbanrenewal/select/login',
        query: tenant ? { tenant } : {},
      });
    },
  },
};
</script>
